import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrDoubleArrowUpIconComponent: TemplateOnlyComponent<Signature> =
  <template>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      class={{@class}}
      ...attributes
    >
      <path
        d='M2.27509 8.50838C1.96282 8.82123 1.54647 8.82123 1.2342 8.50838C0.921932 8.19553 0.921932 7.7784 1.2342 7.46555L7.47955 1.20857C7.58364 1.10428 7.79182 1 8 1C8.20818 1 8.41636 1.10428 8.52045 1.20857L14.7658 7.46555C15.0781 7.7784 15.0781 8.19553 14.7658 8.50838C14.4535 8.82123 14.0372 8.82123 13.7249 8.50838L8 2.77281L2.27509 8.50838ZM8 9.02979L13.7249 14.7654C14.0372 15.0782 14.4535 15.0782 14.7658 14.7654C15.0781 14.4525 15.0781 14.0354 14.7658 13.7225L8.52045 7.46555C8.41636 7.36127 8.20818 7.25698 8 7.25698C7.79182 7.25698 7.58364 7.36127 7.47955 7.46555L1.2342 13.7225C0.921932 14.0354 0.921932 14.4525 1.2342 14.7654C1.54647 15.0782 1.96282 15.0782 2.27509 14.7654L8 9.02979Z'
        fill='currentColor'
      />
    </svg>
  </template>;

export default WrDoubleArrowUpIconComponent;
